/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "user/iam/models.proto" (package "rd.user.iam", syntax proto3)
// tslint:disable
// @ts-nocheck
/**
 * Role enumerates our GCP custom roles. Enum names must be of the form
 * `ROLE_<iam role name>`. All custom role names begin with `rd_iam_`.
 *
 * @generated from protobuf enum rd.user.iam.Role
 */
export enum Role {
    /**
     * @generated from protobuf enum value: ROLE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_ENG = 1;
     */
    RD_IAM_ENG = 1,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_BILLING = 2;
     */
    RD_IAM_INTERNAL_APP_BILLING = 2,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_TESTABLE = 3;
     */
    RD_IAM_INTERNAL_APP_TESTABLE = 3,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_GO_LIVE = 4;
     */
    RD_IAM_INTERNAL_APP_GO_LIVE = 4,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_ACQUISITION = 5;
     */
    RD_IAM_INTERNAL_APP_ACQUISITION = 5,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_IMPLEMENTATION = 6;
     */
    RD_IAM_INTERNAL_APP_IMPLEMENTATION = 6,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_CX_INTEGRATIONS = 7;
     */
    RD_IAM_INTERNAL_APP_CX_INTEGRATIONS = 7,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_SUPPORT = 8;
     */
    RD_IAM_INTERNAL_APP_SUPPORT = 8,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_MESSAGING = 9;
     */
    RD_IAM_INTERNAL_APP_MESSAGING = 9,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_AGREEMENTS = 10;
     */
    RD_IAM_INTERNAL_APP_AGREEMENTS = 10,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_DATA_IN = 11;
     */
    RD_IAM_INTERNAL_APP_DATA_IN = 11
}
